
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0028cc5c96b3d681174d5ed252c7fff3.jpg"
          alt="Eco-friendly paper bags"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          <strong>Premium Paper Bags</strong> for<br />Your Business Needs
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          <strong>Wholesale supplier</strong> of eco-friendly, customizable <strong>paper grocery bags</strong>.<br />
          Quality materials, competitive pricing, and fast delivery nationwide.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#products"
            className="bg-[#5a7c3e] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#4a6c2e] transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            View Product Catalog
          </a>
          <a
            href="#contact"
            className="bg-white text-[#5a7c3e] px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-50 transition-all hover:scale-105 whitespace-nowrap cursor-pointer shadow-lg"
          >
            Request Bulk Quote
          </a>
        </div>
        <div className="mt-12 flex items-center justify-center gap-8 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-checkbox-circle-fill text-2xl text-[#a8d08d]"></i>
            <span className="text-sm font-medium">100% Recycled</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-truck-fill text-2xl text-[#a8d08d]"></i>
            <span className="text-sm font-medium">Fast Shipping</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-star-fill text-2xl text-[#a8d08d]"></i>
            <span className="text-sm font-medium">Made in USA</span>
          </div>
        </div>
      </div>
    </section>
  );
}
